import Layout from 'layout/Layout';

import {
  Login,
  Dashboard,
  Otp,
  Vendor,
  ViewVendor,
  SubVendorView,
  VechileSubVendorView,
  DriverTable,
  DriverView,
  ViewDriverVendor,
  CustomerTable,
  CustomerView,
  ComplianceTable,
  ComplianceDocument,
  RideTrack,
  RideTrackView,
  FeedbackTable,
  FeedbackBrief,
  Notification,
  Settings,
  AddComplianceView,
  AddFeedbackView,
  AddCabView,
  TableSubVendor,
  VechileTable,
  AssignTripView,
  AssignVechileView,
  AssignDriverView,
  FAQ,
  TripDetails,
  CustomerHelpFAQ,
  FAQView,
  ComplianceUpload,
  SupportConsole,
  // Reports,
  Invoice,
  AddSubVendorDriver,
  PolicyView,
  RateCard,
  InvoiceDetails,
  CustomerPolicy,
  CustomerAboutUs,
  CustomerTAC,
  DeleteAccount,
  Customer,
  Booking,
  Revenue,
  couponReport,
  couponTable,
  CouponDetails,
  MapTest,
  TripBookingDetails,
  Help,
} from './components';
import LiveCabsMap from 'pages/liveTracking/LiveCabsMap';
import CustomerComplaintsTable from 'pages/customerComplaints/CustomerComplaintsTable';
import CustomerComplaintView from 'pages/customerComplaints/CustomerComplaintView';
import RateCardV1 from 'pages/configuration/rateCardV1/rateCardV1';
import CityConfig from 'pages/configuration/rateCardV1/CityConfig';
import CityConfigForm from 'pages/configuration/rateCardV1/CityConfigForm';
import TollCharge from 'pages/configuration/tollCharge/TollCharge';
import ServiceableZones from 'pages/configuration/serviceableZones/ServiceableZones';
import StaticBanner from 'pages/promotional/staticBanner/staticBanner';
import PromotionalTab from 'pages/promotional/PromotionalTab';
import GeneratedReports from 'pages/reports/genartedReports/GeneratedReports';
import AccountSettings from 'pages/settings/AccountSettings';
import AdminSettingConfig from 'pages/settings/AdminSettingConfig';
import Reservation from 'pages/reservation/Reservation';
import CommonRideView from 'pages/reservation/CommonRideView';
import BookACab from 'pages/reservation/BookACab';
import Home from 'pages/reservation/Home';
import ConfirmPay from '../pages/reservation/ComfirmPay';

export const routeConfigAuth = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  {
    path: '/faq',
    component: CustomerHelpFAQ,
    layout: null,
    isAuth: false,
  },
  { path: 'shareTrip', component: TripDetails, layout: null, isAuth: false },
  { path: 'privacy-policy', component: CustomerPolicy, layout: null, isAuth: false },
  { path: 'termsandconditions', component: CustomerTAC, layout: null, isAuth: false },
  { path: 'aboutus', component: CustomerAboutUs, layout: null, isAuth: false },
  { path: '/download-invoice/:id/:magicToken', component: InvoiceDetails, layout: null, isAuth: false },
  { path: '/maps', component: MapTest, layout: null, isAuth: false },
  { path: "/help", component: Help, layout: null, isAuth: false },
  { path: '/delete-account', component: DeleteAccount, layout: null, isAuth: false },
];

export const routeConfigDynamic = [
{ path: "/", component: Login, layout: null, isAuth: false },
{ path: "/login", component: Login, layout: null, isAuth: false },
{ path: "/otp", component: Otp, layout: null, isAuth: false },
{path: "/liveTracking", component: LiveCabsMap, layout: Layout, isAuth: true, moduleKey:"liveTracking"},
{ path: '/dashboard', component: Dashboard, layout: Layout, isAuth: true, moduleKey: "dashboard"},
{ path: '/customer', component: CustomerTable, layout: Layout, isAuth: true, moduleKey: "customer" },
{ path: '/customer/detail', component: CustomerView, layout: Layout, isAuth: true, moduleKey: "customer"},
{ path: '/complaints', component: CustomerComplaintsTable, layout: Layout, isAuth: true, moduleKey: "complaints"},
{ path: '/complaints/detail', component: CustomerComplaintView, layout: Layout, isAuth: true, moduleKey: "complaints"},
{ path: '/driver', component: DriverTable, layout: Layout, isAuth: true, moduleKey: "owndrivers" },
{ path: '/driver/vehicle', component: VechileSubVendorView, layout: Layout, isAuth: true, moduleKey: "owndrivers" },
{ path: '/driver/details', component: DriverView, layout: Layout, isAuth: true, moduleKey: "owndrivers" },
{ path: '/rideTrack/:tabs', component: RideTrack, layout: Layout, isAuth: true, moduleKey: "tracktrip" },
{
  path: '/rideTrack/details',
  component: RideTrackView,
  layout: Layout,
  isAuth: true,
  moduleKey: "tracktrip"
},
{
  path: '/rideTrack/details/:id',
  component: RideTrackView,
  layout: Layout,
  isAuth: true,
  moduleKey: "tracktrip"
},
{
  path: '/rideTrack/map',
  component: MapTest,
  layout: Layout,
  isAuth: true,
  moduleKey: "tracktrip"
},
{
  path: '/compliance/:tabs',
  component: ComplianceTable,
  layout: Layout,
  isAuth: true,
  moduleKey: "compliance"
},
{
  path: '/compliance/documents',
  component: ComplianceDocument,
  layout: Layout,
  isAuth: true,
  moduleKey: "compliance"
},
{
  path: '/feedback/details',
  component: FeedbackBrief,
  layout: Layout,
  isAuth: true,
  moduleKey: "feedback"
},
{
  path: '/notification',
  component: Notification,
  layout: Layout,
  isAuth: true,
  moduleKey: "notification"
},
{ path: '/account', component: AccountSettings, layout: Layout, isAuth: true, moduleKey: "settings"},
{ path: '/adminSetting', component: AdminSettingConfig, layout: Layout, isAuth: true, moduleKey: "settings"},
{ path: '/support', component: SupportConsole, layout: Layout, isAuth: true, moduleKey: "support" },
{ path: '/booking', component: Booking, layout: Layout, isAuth: true, moduleKey: "booking" },
{ path: '/coupon-report', component: couponReport, layout: Layout, isAuth: true, moduleKey: "coupon" },
{ path: '/trip-details-report', component: TripBookingDetails, layout: Layout, isAuth: true, moduleKey: "booking" },
{ path: '/report-generate', component: GeneratedReports, layout: Layout, isAuth: true, moduleKey: "booking" },
{ path: '/customer', component: Customer, layout: Layout, isAuth: true, moduleKey: "customer" },
{ path: '/invoice', component: Invoice, layout: Layout, isAuth: true, moduleKey: "invoice" },
{ path: '/invoice/:tabs', component: Invoice, layout: Layout, isAuth: true, moduleKey: "invoice" },
{ path: '/invoice/detail', component: InvoiceDetails, layout: Layout, isAuth: true, moduleKey: "invoice" },
{ path: '/feedback', component: FeedbackTable, layout: Layout, isAuth: true, moduleKey: "feedback" },

{
  path: '/subvendor',
  component: TableSubVendor,
  layout: Layout,
  isAuth: true,
  moduleKey: "subvendors"
},
{
  path: '/subvendor/details',
  component: SubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "subvendors"
},
{
  path: '/subvendor/vehicle',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "subvendors"
},
{
  path: '/subvendor/driver',
  component: ViewDriverVendor,
  layout: Layout,
  isAuth: true,
  moduleKey: "subvendors"
},
{ path: '/Vehicle', component: VechileTable, layout: Layout, isAuth: true, moduleKey: "vehicle" },
{
  path: '/Vehicle/details',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "vehicle"
},
{
  path: '/uploadcompliance',
  component: ComplianceUpload,
  layout: Layout,
  isAuth: true,
},
{
  path: '/add',
  component: AddSubVendorDriver,
  layout: Layout,
  isAuth: true,
},
{ path: '/vendor', component: Vendor, layout: Layout, isAuth: true, moduleKey: "citymanager" },
{
  path: '/vendor/:city/:tabs',
  component: ViewVendor,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/driver',
  component: ViewDriverVendor,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/driver/vehicle',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/vehicle',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/subvendor',
  component: SubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/subvendor/driver',
  component: ViewDriverVendor,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/subvendor/driver/vehicle',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/vendor/subvendor/vehicle',
  component: VechileSubVendorView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{
  path: '/addcomplaince',
  component: AddComplianceView,
  layout: Layout,
  isAuth: true,
  moduleKey: "compliance"
},
{
  path: '/addfeedback',
  component: AddFeedbackView,
  layout: Layout,
  isAuth: true,
  moduleKey: "feedback"
},
{
  path: '/addcabcategory',
  component: AddCabView,
  layout: Layout,
  isAuth: true,
  moduleKey: "vehiclecategory"
},
{
  path: '/policy',
  component: PolicyView,
  layout: Layout,
  isAuth: true,
  moduleKey: "citymanager"
},
{ path: '/faq/:tabs', component: FAQ, layout: Layout, isAuth: true, moduleKey: "faq" },
{ path: '/faq/details/:tabs', component: FAQView, layout: Layout, isAuth: true, moduleKey: "faq" },
// { path: '/ratecard', component: RateCard, layout: Layout, isAuth: true, moduleKey: "ratecard"},
{ path: '/ratecard', component: RateCardV1, layout: Layout, isAuth: true, moduleKey: "ratecard"},
{ path: '/tollCharges', component: TollCharge, layout: Layout, isAuth: true, moduleKey: "tollCharges"},
{ path: '/serviceableZones', component: ServiceableZones, layout: Layout, isAuth: true, moduleKey: "serviceableZones"},
// { path: '/coupon', component: couponTable, layout: Layout, isAuth: true, moduleKey: "coupon"},
{ path: '/promotions', component: PromotionalTab, layout: Layout, isAuth: true, moduleKey: "coupon"},
{ path: '/reservation', component: Reservation, layout: Layout, isAuth: true, moduleKey: "coupon"},
{ path: '/coupon/details', component: CouponDetails, layout: Layout, isAuth: true, moduleKey: "coupon"},
{ path: '/staticbanner', component: StaticBanner, layout: Layout, isAuth: true, moduleKey: "coupon"},
{ path: '/ride', component: Home, layout: Layout, isAuth: true, moduleKey: "coupon"},
  {
    path: "/rideDetails",
    component: ConfirmPay,
    layout: Layout,
    isAuth: true,
    moduleKey: "coupon"
  },
{
  path: '/assignTrip',
  component: AssignTripView,
  layout: Layout,
  isAuth: true,
  moduleKey: "assigntrip"
},
{
  path: '/assignVehicle',
  component: AssignVechileView,
  layout: Layout,
  isAuth: true,
  moduleKey: "assignvehicle"
},
{
  path: '/assignDriver',
  component: AssignDriverView,
  layout: Layout,
  isAuth: true,
  moduleKey: "assigndriver"
},
{
  path: '/city-config/:cityName',
  component: CityConfig,
  layout: Layout,
  isAuth: true,
  moduleKey: "compliance"
},
// {
//   path: '/city-config-form',
//   component: CityConfigForm,
//   layout: Layout,
//   isAuth: true,
//   moduleKey: "compliance"
// },
]
